export type NumericInput = number | string | null | undefined;

/** 安全转数字：非数字、NaN、Infinity 一律回 0，避免 `NaN` 污染金额合计。 */
export function toNumber(value: NumericInput): number {
  if (typeof value === 'number') return Number.isFinite(value) ? value : 0;
  if (typeof value === 'string') {
    const parsed = Number(value.replace(/,/g, '').trim());
    return Number.isFinite(parsed) ? parsed : 0;
  }
  return 0;
}

function formatDecimal(value: NumericInput, digits: number): string {
  const fixed = toNumber(value).toFixed(digits);
  // 只对整数部分做千分位；直接对整串加逗号会把小数位切成 "2.4,000"
  const [integer = '0', fraction] = fixed.split('.');
  const grouped = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return fraction === undefined ? grouped : `${grouped}.${fraction}`;
}

/** 金额：后端 `decimal(18,2)`。 */
export function formatAmount(value: NumericInput, digits = 2): string {
  return formatDecimal(value, digits);
}

/** 单价：后端 `decimal(18,4)`。 */
export function formatPrice(value: NumericInput, digits = 4): string {
  return formatDecimal(value, digits);
}

/** 数量：后端 `decimal(18,3)`，库存统计统一用基本单位数量 qty_base（DR-6.3）。 */
export function formatQty(value: NumericInput, digits = 3): string {
  return formatDecimal(value, digits);
}

/**
 * 比率/税率：后端统一存 0~1 小数（如 0.13 = 13%）。
 * 直接拼 `%` 会把 0.13 显示成 "0.13%"，故展示必须 ×100。
 */
export function formatPercent(value: NumericInput, digits = 2): string {
  const percent = toNumber(value) * 100;
  return `${Number(percent.toFixed(digits))}%`;
}

/**
 * 表单里按「百分数」录入（13 表示 13%），提交时换算成后端口径的 0~1 小数。
 * 全站约定：界面一律百分数，报文一律 0~1，避免同一个字段出现两套量纲。
 */
export function percentToRatio(value: NumericInput): number {
  return toNumber(value) / 100;
}
